import { render, staticRenderFns } from "./integration-rule.vue?vue&type=template&id=67eac434&scoped=true"
import script from "./integration-rule.vue?vue&type=script&lang=js"
export * from "./integration-rule.vue?vue&type=script&lang=js"
import style0 from "./integration-rule.vue?vue&type=style&index=0&id=67eac434&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eac434",
  null
  
)

export default component.exports